import { whenDomReady } from "@allwyn/utils/document-ready";

const richTextPhotos = document.querySelectorAll("[data-js-rich-text-photo]");

const observer = new IntersectionObserver(
    (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const el = entry.target as HTMLElement;

                el.querySelector("img")?.removeAttribute("loading");
                observer.unobserve(el);
                observer.disconnect();
            }
        });
    },
    { threshold: 0.1 }
);

function initializeRichTextPhoto() {
    if (!richTextPhotos.length) return;

    richTextPhotos.forEach((el) => {
        observer.observe(el);
    });
}

await whenDomReady();

initializeRichTextPhoto();
